import React, {useRef, useState} from 'react';
import Cropper from 'react-easy-crop';
import axios from 'axios';
import UKFlag from './UKFlag.png';
import GeoFlag from './geoflag.svg';
import './NewsUpload.css';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import NewsManager from "./NewsManager";
import '../ImageCropper/ImageCropper.css'
import getCroppedImg from "../ImageCropper/imageUtils"
import ImgDialog from '../ImageCropper/ImgDialog';
import JoditEditor from "jodit-react";
import {Button, Checkbox, DialogTitle, FormControlLabel, TextField} from "@mui/material";

const NewsUpload = () => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [file, setFile] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [fileName, setFileName] = useState('');
    const [fileURL, setFileURL] = useState('');
    const [titleEng, setTitleEng] = useState('');
    const [descriptionShortEng, setDescriptionShortEng] = useState('');
    const [descriptionShort, setDescriptionShort] = useState('');
    const [descriptionEng, setDescriptionEng] = useState('');
    const [croppedImageUrl, setCroppedImageUrl] = useState(null);
    const [isResultModalOpen, setIsResultModalOpen] = useState(false);
    const [crop, setCrop] = useState({x: 0, y: 0});
    const [zoom, setZoom] = useState(1);
    const [rotation, setRotation] = useState(0)
    const [croppedArea, setCroppedArea] = useState(null);
    const [showCropper, setShowCropper] = useState(false);
    const [blobTobase64String, setblobTobase64String] = useState(null);
    const editor = useRef(null);
    const [isTemplate, setIsTemplate] = useState(false);
    const [buttonText, setButtonText] = useState('');
    const [buttonTextEng, setButtonTextEng] = useState('');
    const [onAdd, setOnAdd] = useState(1);
    const georgianTranslations = {
        "Type something": " ",
        "Bold": "ტექსტის გამუქება",
        "Italic": "დახრილი ტექსტის შექმნა",
        "Underline": "ტექსტის ხაზგასმა",
        "Insert Image": "სურათის ჩასმა",
        "Clear Formatting": "ფორმატირების წაშლა",
        "Insert Format Block": "ფორმატირების ბლოკის ჩასმა",
        "Strike through": "გადახაზული",
        "Insert Unordered List": "ბურთულებიანი სიის შექმნა",
        "Insert Ordered List": "დანომრილი სიის შექმნა",
        "Font family": "შრიფტის არჩევა",
        "Font size": "შრიფტის ზომა",
        "Line height": "ხაზის დაშორება",
        "Insert Horizontal Line": "ხაზის დაშორება",
        "Increase Indent": "დაშორების გაზრდა",
        "Decrease Indent": "დაშორების შემცირება",
        "Undo": "უკუსვლა",
        "Redo": "საწყისი",
        "Align": "სწორება",
        "Insert Special Character": "სპეც. სიმბოლო",
        "Fill color or set the text color": "ფერის შეცვლა",
        "Background": "ფონი",
        "Text": "ტექსტი",
        "Insert format block": "ფორმატირება",
        "Print": "დაბეჭვდა",
        "Show all": "მეტის ნახვა",
        "Insert link": "ბმლის ჩასმა",
        "URL": "ბმული",
        "Open in new tab": "ახალ გვერდზე გახსნა",
        "Insert": "ჩასმა"
    };

    const configGeo = {
        placeholder: "ტექსტი ქართულად...",
        readonly: false,
        toolbarButtonSize: "middle",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        language: 'ka',
        i18n: {
            ka: georgianTranslations,
        },
        height: 800,
        width: 1100,
        disablePlugins: [
            'table',
            'spellcheck',
            'speech-recognize',
            'open-in-fullsize',
            'add-new-line',
            'Insert-file',
            'link',
            'ai-assistant',
            'file',
            'image',
            'video',
            'fullsize',
            'about',
            'preview',
            'symbols',
        ],
        controls: {
            font: {
                list: {
                    'Arial': 'Arial',
                    'Sylfaen': 'Sylfaen'
                }
            }
        },
        buttons: [
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'ul', 'ol', '|',
            'outdent', 'indent', '|',
            'font', 'fontsize', 'brush', 'paragraph', '|',
            'image', 'table', 'link', '|',
            'align', 'undo', 'redo', '|',
            'hr', 'eraser', 'copyformat', '|',
            'symbol', 'fullsize', 'print', 'about'
        ],
    };

    const configEng = {
        placeholder: "ტექსტი ინგლისურად...",
        readonly: false,
        toolbarButtonSize: "middle",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        language: 'ka',
        i18n: {
            ka: georgianTranslations,
        },
        height: 800,
        width: 1100,
        disablePlugins: [
            'table',
            'spellcheck',
            'speech-recognize',
            'open-in-fullsize',
            'add-new-line',
            'Insert-file',
            'link',
            'ai-assistant',
            'file',
            'image',
            'video',
            'fullsize',
            'about',
            'preview',
            'symbols',
        ],
        controls: {
            font: {
                list: {
                    'Arial': 'Arial',
                    'Sylfaen': 'Sylfaen'
                }
            }
        },
        buttons: [
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'ul', 'ol', '|',
            'outdent', 'indent', '|',
            'font', 'fontsize', 'brush', 'paragraph', '|',
            'image', 'table', 'link', '|',
            'align', 'undo', 'redo', '|',
            'hr', 'eraser', 'copyformat', '|',
            'symbol', 'fullsize', 'print', 'about'
        ],
    };
    const resetForm = () => {
        setTitle('');
        setDescription('');
        setFile(null);
        setFileName('');
        setFileURL('');
        setTitleEng('');
        setDescriptionShortEng('');
        setDescriptionEng('');
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFile(reader.result);
                setFileName(file.name);
                setFileURL(URL.createObjectURL(file));
                setShowCropper(true);
            };
            reader.readAsDataURL(file);
        } else {
            alert('არაწორი ფორმატი');
        }
        e.target.value = null;  // Reset file input
    };


    const onCropComplete = (croppedAreaPercentage, croppedAreaPixels) => {
        setCroppedArea(croppedAreaPixels);
    };


    const handleCrop = async () => {

        try {
            const croppedImage = await getCroppedImg(
                fileURL,
                croppedArea,
                rotation
            );
            setFile(croppedImage);
            setCroppedImageUrl(croppedImage);
            convertBlobUrlToBase64(croppedImage)
                .then(base64String => {
                    setblobTobase64String(base64String);
                })
        } catch (e) {
        }
    };

    async function convertBlobUrlToBase64(blobUrl) {
        try {
            const response = await fetch(blobUrl);
            const blob = await response.blob();

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    // The result contains the data URL which is Base64 encoded
                    const base64String = reader.result.split(',')[1];
                    resolve(base64String);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            throw error;
        }
    }


    const handleDeleteFile = () => {
        setFile(null);
        setFileName('');
        setFileURL('');
        setShowCropper(false);
        document.getElementById('file-upload').value = null;  // Reset file input
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        void handleCrop();
        setIsModalOpen(true);
        setShowCropper(false);
    };

    const handleConfirm = async () => {
        setIsModalOpen(false); // Close the modal

        const jwtToken = localStorage.getItem('jwtToken');
        if (!jwtToken) {
            setAlertMessage('JWT Token is not available.');
            setAlertType('error');
            setShowAlert(true);
            return;
        }

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNews`, {
                title,
                descriptionShort,
                description,
                file: file ? {
                    base64String: blobTobase64String,
                    ext: file.includes('image/png') ? 'png' : 'jpg'
                } : null,
                hasMore: true,
                titleEng,
                descriptionShortEng,
                descriptionEng,
                isTemplate,
                buttonText,
                buttonTextEng
            }, {
                headers: {Authorization: `Bearer ${jwtToken}`}
            });
            resetForm();
            setAlertMessage('სიახლე აიტვირთა წარმატებით');
            setAlertType('success');
        } catch (error) {
            setAlertMessage('დაფიქსირდა შეცდომა');
            setAlertType('error');
        }
        setShowAlert(true);
        setOnAdd(Math.floor(Math.random() * 1000000));


    };
    const isFormValid = () => {
        return title.trim() !== '' &&
            titleEng.trim() !== '' &&
            description.trim() !== '' && descriptionEng.trim() !== '' &&
            fileName !== '';

    };


    const handleCloseModal = () => {
        setIsResultModalOpen(false);
    };

    return (
        <div className="news-upload-container">
            <h1 className="page-manager-title">სიახლის დამატება</h1>
            <form onSubmit={handleSubmit} className="news-upload-form">


                <label htmlFor="file-upload" className="custom-file-upload">
                    {fileName || 'სურათის ატვირთვა (png, jpg)'}
                </label>
                <input id="file-upload" type="file" name="file" onChange={handleFileChange} accept=".png,.jpg"
                       className="employee-file-input"/>
                {showCropper && (
                    <div className="crop-container">
                        <Cropper
                            image={fileURL}
                            crop={crop}
                            zoom={zoom}
                            rotation={rotation}
                            aspect={665 / 350}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onRotationChange={setRotation}
                            onCropComplete={onCropComplete}
                        />

                        <div className="controls">
                            <label>ზუმი:</label>
                            <input
                                type="range"
                                value={zoom}
                                min={0.01}
                                max={3}
                                step={0.1}
                                aria-labelledby="Zoom"
                                onChange={(e) => {
                                    setZoom(e.target.value)
                                }}
                                className="zoom-range"
                            />
                            <label>როტაცია:</label>
                            <input
                                type="range"
                                value={rotation}
                                min={0.01}
                                max={360}
                                step={1}
                                aria-labelledby="Rotation"
                                onChange={(e) => {
                                    setRotation(e.target.value)
                                }}
                                className="rotation-range"
                            />
                        </div>
                    </div>
                )}

                {isResultModalOpen && (
                    <ImgDialog imageUrl={croppedImageUrl} onClose={handleCloseModal}/>
                )}
                {fileName && (
                    <div className="file-actions">

                        <button onClick={handleDeleteFile} className="delete-image-button">
                            სურათის წაშლა
                        </button>
                    </div>
                )}

                <div className="news-manager-flag-title">
                    <DialogTitle>ტექსტი ქართულად</DialogTitle>
                    <img src={GeoFlag} alt="Gep Flag" className="news-flag"/>
                </div>
                <input type="text" placeholder="სათაური" value={title} onChange={(e) => setTitle(e.target.value)}
                       className="input-field"/>
                <JoditEditor
                    ref={editor}
                    value={description}
                    config={{...configGeo, placeholder: "სრული ტექსტი" }}
                    tabIndex={1}
                    onBlur={newContent => setDescription(newContent)}
                />
                <div className="news-manager-flag-title">
                    <DialogTitle>აღწერა</DialogTitle>
                    <img src={GeoFlag} alt="Gep Flag" className="news-flag"/>
                </div>
                <JoditEditor
                    ref={editor}
                    value={descriptionShort}
                    config={{...configGeo, placeholder: "მოკლე აღწერა" }}
                    tabIndex={1}
                    onBlur={newContent => setDescriptionShort(newContent)}
                />
                <div className="news-manager-flag-title">
                    <DialogTitle>ტექსტი ინგლისურად</DialogTitle>
                    <img src={UKFlag} alt="Uk Flag" className="news-flag"/>
                </div>
                <input type="text" placeholder="Title in English" value={titleEng}
                       onChange={(e) => setTitleEng(e.target.value)} className="input-field"/>
                <JoditEditor
                    ref={editor}
                    value={descriptionEng}
                    config={{ ...configEng, placeholder: 'სრული ტექსტი ინგლისურად ' }}
                    tabIndex={1}
                    onBlur={newContent => setDescriptionEng(newContent)}
                />
                <div className="news-manager-flag-title">
                    <DialogTitle>აღწერა ინგლისურად</DialogTitle>
                    <img src={UKFlag} alt="Uk Flag" className="news-flag"/>
                </div>
                <JoditEditor
                    ref={editor}
                    value={descriptionShortEng}
                    config={{ ...configEng, placeholder: 'მოკლე აღწერა ინგლისურად' }}
                    tabIndex={1}
                    onBlur={newContent => setDescriptionShortEng(newContent)}
                />
                <TextField
                    margin="dense"
                    label="ღილაკის ტექსტი"
                    type="text"
                    fullWidth
                    variant="outlined"
                    name="buttonText"
                    value={buttonText}
                    onChange={(e) => setButtonText(e.target.value)}
                />
                <TextField
                    margin="dense"
                    label="ღილაკის ტექსტი ინგლისურად"
                    type="text"
                    fullWidth
                    variant="outlined"
                    name="buttonTextEng"
                    value={buttonTextEng}
                    onChange={(e) => setButtonTextEng(e.target.value)}
                />
                <FormControlLabel
                    style={{marginRight: 70}}
                    control={<Checkbox checked={isTemplate}
                                       onChange={(e) => {
                                           setIsTemplate(e.target.checked);
                                       }}/>}
                    label="შაბლონად შენახვა"
                />
                <button disabled={title.trim() === ''} type="submit" className="submit-button-news">ატვირთვა</button>
            </form>

            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                onConfirm={handleConfirm}
            />
            {showAlert && (
                <CustomAlert
                    message={alertMessage}
                    type={alertType}
                    onClose={() => setShowAlert(false)}
                />
            )}
            <NewsManager onAdd={onAdd} />
        </div>
    );
};

export default NewsUpload;